// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App___1o-Fp","App-logo":"App__App-logo___3JCPt","App-logo-spin":"App__App-logo-spin___RvI1J","App-header":"App__App-header___3iH8L","App-intro":"App__App-intro___1OgPc"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 118
// module chunks = 0